import script from "./ListingColumns.vue?vue&type=script&setup=true&lang=js"
export * from "./ListingColumns.vue?vue&type=script&setup=true&lang=js"

import "./ListingColumns.vue?vue&type=style&index=0&id=cc89fac2&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc89fac2"]])

export default __exports__